<template>
	<b-card no-body>
        
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <tax-administration-create-or-update v-model="taxAdministration" :errors="errors"></tax-administration-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :fields="fields"
                    name="carrier-classification"
                    :buttons="buttons"
                    pagination = "server"
                    search
                    :items-provider="provider"
                    ></v-table>
    </b-card>
</template>

<script>
import {BCard} from 'bootstrap-vue'
import TaxAdministrationCreateOrUpdate from './components/TaxAdministrationCreateOrUpdate.vue'
import SystemDataApi from '@/api/system-data'

export default {
	components:{
        BCard,
        TaxAdministrationCreateOrUpdate,
	},
	data(){
		return{
			editing:false,
            errors:{},
            loading:false,
            taxAdministration:{
                Id:0,
                Name:null,
                ProvinceId:null
            },
            fields:[
                { name:"Vergi Ofisi",key:"Name", thClass:"w-50",sortable:true},
                { name:"İl",key:"ProvinceName", thClass:"w-50"},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
		}
	},
	methods:{
		clearForm(){
            this.editing = false
            this.taxAdministration.Id = 0
            this.taxAdministration.Name = null
            this.taxAdministration.ProvinceId = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.taxAdministration.Id = item.Id
            this.taxAdministration.Name = item.Name
            this.taxAdministration.ProvinceId = item.ProvinceId
            this.$showModal('create-or-update')
        },
        provider(data){
            return SystemDataApi.TaxAdministration.Table(data)
        },
        createOrUpdate(){
            this.loading = true
            SystemDataApi.TaxAdministration.CreateOrUpdate(this.editing,this.taxAdministration)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
            .catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} isimli vergi ofisini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    SystemDataApi.TaxAdministration.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
	}
}
</script>

<style>

</style>